// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pddbbryweczasnvppapr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBkZGJicnl3ZWN6YXNudnBwYXByIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc3NDEyNTMsImV4cCI6MjA1MzMxNzI1M30.upRmlrrsk4VBF8eb2_m0By2yWbwXYAnosy0oHdD17iA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);